export default "__VITE_ASSET__Cce1vwcm__"